<template>
    <div class="device-management-container">
        <div class="devices-list" v-if="devices.length>0">
            <div 
                v-for="(device, index) in devices" 
                :key="device.id" 
                class="device-item"
            >
                <div class="device-item-header">
                    <div class="device-item-title">
                        <div class="device-number">设备{{ index + 1 }}</div>
                        <div class="device-name">（{{ device.equipmentTypeName }}）</div>
                    </div>
                </div>
                
                <div class="device-content">
                    <div class="upload-section-title">安装现场图片上传</div>
                    <div class="upload-hint">请上传设备的安装现场图片（仅支持jpg/png格式）</div>
                    
                    <el-upload 
                        class="upload-area" 
                        :action="actionUrl"  
                        :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, device.id)"  
                        :before-upload="beforeUpload"
                        :multiple="true" 
                        :on-exceed="handleExceed"
                        :file-list="deviceImagesMap[device.id] || []"
                        list-type="picture-card" 
                        :on-preview="(file) => handlePictureCardPreview(file)"
                        :on-remove="(file, fileList) => handleRemove(file, fileList, device.id)"
                        :auto-upload="true">
                        <i class="el-icon-plus"></i>
                        <div class="upload-tips">点击上传图片</div>
                    </el-upload>
                    
                    <div class="device-item-actions">
                        <el-button 
                            type="primary" 
                            @click="handleSubmit(device.id)" 
                            :loading="savingMap[device.id] || false"
                            :disabled="!deviceImagesMap[device.id] || deviceImagesMap[device.id].length === 0"
                            class="save-btn"
                        >
                            保存
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else style="text-align: center;margin-top:20px">
           暂无数据
        </div>
        <!-- 图片预览对话框 -->
        <el-dialog :visible.sync="dialogVisible" append-to-body @close="closeWindow">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import baseURL from "@/api/baseURL"
export default {
    props: ['customerId'],
    data() {
        return {
            devices: [],
            dialogImageUrl: '',
            dialogVisible: false,
            // 存储每个设备的图片列表
            deviceImagesMap: {},
            // 存储每个设备的保存状态
            savingMap: {},
            actionUrl:''
        }
    },
    mounted() {
        this.actionUrl = baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
        this.devices = []
       // this.getList()
    },
    methods: {
        getList() {
            this.$http
                .request({
                    url: 'ypt/admin/equipment/info/findList',
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 999,
                        customerId: this.customerId
                    }
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.devices = res.content.list
                            // 初始化所有设备的图片数据
                            this.initAllDeviceImages();
                            // 初始化保存状态
                            this.devices.forEach(device => {
                                this.$set(this.savingMap, device.id, false);
                            });
                        }
                    }
                })
        },
        
        // 初始化所有设备的图片数据
        initAllDeviceImages() {
            // 先清空设备图片映射
            this.deviceImagesMap = {};
            
            // 遍历所有设备，初始化每个设备的图片数据
            this.devices.forEach(device => {
                // 处理设备的photo字段
                let photoUrls = [];
                
                if (device.photo && device.photo.trim() !== '') {
                    try {
                        // 尝试解析photo字段，可能是逗号分隔的字符串或JSON字符串
                        if (device.photo.startsWith('[')) {
                            // 如果是JSON数组字符串
                            photoUrls = JSON.parse(device.photo);
                        } else {
                            // 如果是逗号分隔的字符串
                            photoUrls = device.photo.split(',').filter(url => url.trim() !== '');
                        }
                    } catch (error) {
                      //  console.error('解析设备图片数据失败:', device.id, device.photo, error);
                        photoUrls = [];
                    }
                }
                
                // 将解析出的URL数组转换为el-upload需要的格式
                this.deviceImagesMap[device.id] = photoUrls.map((url, index) => ({
                    name: `device_${device.id}_${index + 1}.jpg`,
                    url: url.trim(),
                    uploadTime: new Date().toLocaleString()
                }));
                
              //  console.log(`设备 ${device.id} 的图片数据:`, this.deviceImagesMap[device.id]);
            });
        },
        
        // 上传成功处理
        handleUploadSuccess(response, file, fileList, deviceId) {
           /// console.log('单张图片上传成功:', response, '设备ID:', deviceId);
            
            // 确保设备的图片列表存在
            if (!this.deviceImagesMap[deviceId]) {
                this.$set(this.deviceImagesMap, deviceId, []);
            }
            
            // 从上传响应中获取图片URL地址
            let imageUrl = '';
            if (response && response.content) {
                imageUrl = response.content;
            }
            
            if (imageUrl) {
                this.deviceImagesMap[deviceId].push({
                    name: file.name,
                    url: imageUrl, // 使用服务器返回的图片URL
                    uploadTime: new Date().toLocaleString()
                });
                this.$message.success('图片上传成功！');
            } else {
            //    console.error('获取图片URL失败:', response);
                this.$message.error('图片上传失败，无法获取图片地址');
            }
        },

        // 上传前处理 - 批量处理
        beforeUpload(file) {
            const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt5M = file.size / 1024 / 1024 < 5;

            if (!isImage) {
                this.$message.error(`文件 "${file.name}" 不是JPG/PNG格式！`);
                return false;
            }
            if (!isLt5M) {
                this.$message.error(`图片 "${file.name}" 大小不能超过5MB！`);
                return false;
            }

            return true;
        },

        // 超过限制处理
        handleExceed(files, fileList) {
           this.$message.warning(`最多只能上传10张图片`);
        },

        // 图片预览
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        
        closeWindow(){
           this.dialogVisible = false;
        },
        
        // 移除图片
        handleRemove(file, fileList, deviceId) {
        //    console.log('移除文件:', file, '设备ID:', deviceId);
            // 从设备的图片列表中移除
            if (this.deviceImagesMap[deviceId]) {
                const imageIndex = this.deviceImagesMap[deviceId].findIndex(
                    img => img.name === file.name
                );
                if (imageIndex !== -1) {
                    this.deviceImagesMap[deviceId].splice(imageIndex, 1);
                    this.$message.success('图片已移除');
                }
            }
        },
        
        // 保存设备图片
        handleSubmit(deviceId) {
            if (!this.deviceImagesMap[deviceId] || this.deviceImagesMap[deviceId].length === 0) {
                this.$message.warning('请先上传图片');
                return;
            }
            // 设置保存状态
            this.$set(this.savingMap, deviceId, true);
            
            // 提取所有图片的URL地址
            let url = [];
            this.deviceImagesMap[deviceId].forEach((item) => {
                if (item.url && item.url.trim() !== '') {
                    url.push(item.url.trim());
                }
            });
            
            // 准备保存的数据 - 保存为逗号分隔的字符串
            const saveData = {
                id: deviceId, // 设备ID
                photo: url.join(',')  // 使用逗号分隔的字符串
            };
            
            console.log('保存数据:', saveData);
            
            // 调用API保存设备的图片
            this.$http
                .request({
                    url: 'ypt/admin/equipment/info/update',
                    method: "POST",
                    data: saveData
                })
                .then((res) => {
                    if (res.code === 200) {
                        this.$message.success('设备图片保存成功！');
                        
                        // 更新对应设备的photo字段
                        const deviceIndex = this.devices.findIndex(device => device.id === deviceId);
                        if (deviceIndex !== -1) {
                            this.devices[deviceIndex].photo = saveData.photo;
                        }
                    } else {
                        this.$message.error(res.msg || '保存失败');
                    }
                })
                .catch((error) => {
                    console.error('保存失败:', error);
                    this.$message.error('保存失败，请重试');
                })
                .finally(() => {
                    this.$set(this.savingMap, deviceId, false);
                });
        }
    }
}
</script>

<style lang="less" scoped>
.device-management-container {
    width: 90%;
    background-color: #fff;
    padding: 0 20px 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.page-header {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
    
    .page-title {
        font-size: 24px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 8px;
    }
    
    .page-subtitle {
        font-size: 14px;
        color: #909399;
    }
}

.devices-list {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.device-item {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 20px;
    background-color: #fff;
    
    &:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    
    .device-item-header {
        margin-bottom: 10px;
        padding-bottom: 15px;
        border-bottom: 1px solid #f0f0f0;
        
        .device-item-title {
            display: flex;
            align-items: baseline;
            margin-bottom: 10px;
            
            .device-number {
                font-size: 18px;
                font-weight: 600;
                color: #303133;
                margin-right: 5px;
            }
            
            .device-name {
                font-size: 18px;
                color: #303133;
            }
        }
    }
    
    .device-content {
        .upload-section-title {
            font-size: 16px;
            font-weight: 500;
            color: #303133;
            margin-bottom: 8px;
        }
        
        .upload-hint {
            font-size: 14px;
            color: #909399;
            margin-bottom: 20px;
        }
        
        .upload-area {
            margin-bottom: 25px;
            
            ::v-deep .el-upload--picture-card {
                width: 120px;
                height: 120px;
                line-height: 1.2;
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                background-color: #fafafa;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                
                &:hover {
                    border-color: #409eff;
                }
                
                i {
                    font-size: 28px;
                    color: #8c939d;
                    margin-bottom: 8px;
                }
                
                .upload-tips {
                    font-size: 12px;
                    color: #8c939d;
                    text-align: center;
                    padding: 0 5px;
                }
            }
        }
        
        .device-item-actions {
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;
            
            .save-btn {
                min-width: 100px;
                height: 36px;
                font-size: 14px;
            }
        }
    }
}

/* 分割线样式 */
// .device-item + .device-item {
//     margin-top: 20px;
// }

/* 响应式设计 */
@media (max-width: 768px) {
    .device-management-container {
        padding: 15px;
    }
    
    .device-item {
        padding: 16px;
        
        .device-item-header {
            .device-item-title {
                flex-direction: column;
                align-items: flex-start;
                
                .device-number {
                    margin-bottom: 5px;
                }
            }
        }
        
        .device-content {
            .device-item-actions {
                justify-content: center;
            }
        }
    }
}

/* 图片预览对话框样式 */
.el-dialog {
    border-radius: 8px;
    
    .el-dialog__body {
        padding: 20px;
    }
    
    img {
        display: block;
        max-width: 100%;
        height: auto;
        border-radius: 4px;
    }
}
</style>